import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import type { SxProps, Theme } from '@mui/material/styles';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export type SearchAssetsInputProps = {
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  sx?: SxProps<Theme>;
  hideClearButton?: boolean;
};

type LoadingItemProps = {
  isLoading: boolean;
  sx?: SxProps<Theme>;
  hideClearButton?: boolean;
};

export function SearchAssetsInput({ searchTerm, setSearchTerm, sx, hideClearButton }: SearchAssetsInputProps);
export function SearchAssetsInput({ isLoading, sx, hideClearButton }: LoadingItemProps);
export function SearchAssetsInput({
  searchTerm,
  setSearchTerm,
  isLoading = false,
  sx,
  hideClearButton = false,
}: Partial<SearchAssetsInputProps & LoadingItemProps>) {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm?.(event.currentTarget.value);
  };

  const handleClearSearch = () => {
    setSearchTerm?.('');
    inputRef.current?.focus();
  };

  return (
    <OutlinedInput
      disabled={isLoading}
      sx={{
        borderRadius: '24px',
        color: 'rgba(0, 40, 58, 0.87)',
        height: '2.25rem',
        width: '40%',
        padding: '0 0.875rem',
        ...sx,
      }}
      inputRef={inputRef}
      value={searchTerm}
      onChange={handleSearch}
      placeholder={t('editor.sections.search_placeholder')}
      startAdornment={<SearchIcon data-testid="search-icon" fontSize="small" sx={{ color: 'action.active', mr: 1 }} />}
      endAdornment={
        hideClearButton ? undefined : (
          <IconButton sx={{ color: 'action.active' }} onClick={() => handleClearSearch()}>
            <ClearIcon data-testid="clear-icon" fontSize="small" />
          </IconButton>
        )
      }
    />
  );
}
